/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Documents_Search_NoneInputs */

const cs_documents_search_none = /** @type {(inputs: Documents_Search_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pro „${i?.query}“ nic nenalezeno.`)
};

const en_documents_search_none = /** @type {(inputs: Documents_Search_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nothing found for “${i?.query}”.`)
};

/**
* | output |
* | --- |
* | "Nothing found for “{query}”." |
*
* @param {Documents_Search_NoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_search_none = /** @type {((inputs: Documents_Search_NoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Search_NoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_search_none(inputs)
	return cs_documents_search_none(inputs)
});